import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import ProductCardFinwell from '../card/ProductCardFinwell';
import { useDispatch, useSelector } from 'react-redux';
import { getForYouData, getForYouDataClear, getMyCoursesClear, getProductCategoriesData, getProductCategoriesDataClear } from '../../../redux/courses/actions';
import { convertHoursToMins, convertTimeFormat, getAssetType, getProcureInfo, goToLPDetailUtil, redirectToPageUtil, SessionKeys } from '../../../utils/AppUtils';
import _ from 'lodash';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { duration } from 'moment';
import Loader from '../../../components/Loader/Loader';
import { setIsLoadingGlobal } from '../../../redux/home/actions';
import NotFoundMsg from '../../../components/NewDesign/NotFound/NotFoundMsg';
const settings1 = {
  dots: true,
  arrows: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: false,
  //variableWidth: true,
responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 4,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
};
const ForYou = (props) => {
  const { from,viewMoreForYou,setViewMoreForYou, selectedContentType} = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authBroker = useSelector((state) => state.auth.authBroker);
  var myCourseRes = useSelector((state) => state.courses.forYouData);
  const [myAssetList, setMyAssetList] = React.useState([]);
  const [myAssetListGlobal, setMyAssetListGlobal] = React.useState([]);
  const [courseData, setCourseData] = React.useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isActionPath = selectedContentType.some(item => item.value === "10");
        const selectedContent = selectedContentType
        .filter(item => item.value !== "10")
        .map(item => item.value);
    setIsLoading(true);
    let reqObj = {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          category_id: [],
          search: "",
          page_size: 100,
          page: 1,
          asset_id: selectedContent,
          pillar_id: '',
          is_action_path: isActionPath,
        };
        if (from === "home"){
          reqObj.limit = 8;
        }
    dispatch(
      getForYouData({
        module: "getProductCategoriesDataRecommend",
        postData: reqObj,
      })
    );
  }, [dispatch, selectedContentType])




  useEffect(() => {
    if (!_.isEmpty(myCourseRes)) {
      setIsLoading(false);
      console.log("MY COURSES", myCourseRes);
      if (myCourseRes.status === "success") {
        const cListPayload = myCourseRes.payload.payload;
        if (!_.isEmpty(cListPayload)) {
          const cList = cListPayload.courseList;
          for (let course of cList) {
            if (course.durationUnit === "Hours") {
              course.duration = convertHoursToMins(course.duration);
            }
            course.duration = convertTimeFormat(course.duration, true);
            course.durationUnit = "";
          }
          console.log("MY COURSES--", cList);

          let prodArr = [];
          for (let course of cList) {
            let tags = [];
            let btnTitle = t("Start course");
            if (course.provider?.provider_display_name) {
              tags.push(course.provider.provider_display_name);
            }
            tags.push("Course");
            if (course.lessons) {
              tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
            }
            if (course.duration) {
              tags.push(`${course.duration} ${course.durationUnit}`);
            }
            if (course.views) {
              tags.push(`${course.views} ${t("View")}${course.views > 1 ? "s" : ""}`);
            }
            if (course.crs_progress > 0 && course.crs_progress < 100) {
              btnTitle = t("Resume course");
            } else if (course.crs_progress >= 100) {
              btnTitle = t("Revisit course");
            }
            let priceInfo = getProcureInfo(course.purchased_info);
            course.is_home = true;
            setMyAssetList([]);
            setMyAssetListGlobal([]);
            prodArr.push({
              id: course?.courseId,
              is_like: course?.is_like ? course?.is_like : false,
              is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
              dbId: course?.list_id,
              productType: course?.typ,
              productOrigin: course?.source,
              title: course.name,
              logoURL: course.provider?.provider_img
                ? course.provider?.provider_img
                : "",
              bannerURL: course.imageURL,
              tagsArray: tags,
              description: course.short_description,
              btnTitle: btnTitle,
              progress: course.crs_progress,
              showLikeMenu: true,
              btnAction: () => course?.product_type==="learningpath"?goToLPDetailUtil(course, navigate,  0):redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
              descAction: () => course?.product_type==="learningpath"?goToLPDetailUtil(course, navigate,  0):redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch ),
              bannerAction: () => course?.product_type==="learningpath"?goToLPDetailUtil(course, navigate,  0):redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
              footerLineComp: "",
              showHeader: true,
              showBody: course.short_description ? true : false,
              showFooter: true,
              showProgress: false,
              cardClassName: "",
              rightBtnIcon: "/images/arrow-right.svg",
              lefttBtnIcon: "",
              priceInfo,
              status: course.crs_status,
              asset_type: course?.product_type==="learningpath"?"Action Path":course.asset_name,
              duration: course.duration,
              monitoring_name: course.monitoring_name,
              asset_icon: course?.product_type==="learningpath"?"/images/finwell-img/extension.svg":course?.asset_icon,
              monitoring_icon: course?.monitoring_icon,
              isCoachPick:course?.is_coachpick
            });
          }
          let tempArr = [];
          if(from === "explore" && !viewMoreForYou){
            tempArr = _.cloneDeep(prodArr).slice(0, 4);
          }else{
            tempArr = _.cloneDeep(prodArr);
          }
          
          setMyAssetList(tempArr);
          setMyAssetListGlobal(prodArr)

          dispatch(getForYouDataClear({}));

        }
      }

    }
  }, [myCourseRes, viewMoreForYou]);


  useEffect(() => {
    if(myAssetListGlobal?.length===0){
      return;
    }
    let tempArr = [];
          if(from === "explore" && !viewMoreForYou){
            tempArr = _.cloneDeep(myAssetListGlobal).slice(0, 4);
          }else{
            tempArr = _.cloneDeep(myAssetListGlobal);
          }
          
          setMyAssetList(tempArr);
          setMyAssetListGlobal(tempArr)
  }, [viewMoreForYou]);


  return (
    <>
    <Loader start={isLoading} />
      <section id ="forYouSection" aria-labelledby="continue-journey-heading" className='mb-2rem'>
        <div class="continue-section">
          <div class="left">
            <h3>For you</h3>
            <p>Content and resources aligned with your interests and goals</p>
          </div>
         {(from ==="explore" && viewMoreForYou) || (from ==="explore" && (_.isEmpty(myAssetList))) ?"": <div class="right">
            <a className="cursor-pointer" 
            tabIndex={0}
            aria-label={from ==="explore"?"View more":"Explore more content"}
             onClick={()=>{
              if(from ==="explore"){
              setViewMoreForYou(!viewMoreForYou);
            }else{
              navigate("/explore?pillar_id=all")
            }
          }}>{from ==="explore"? !viewMoreForYou ? "View more" : '' :"Explore more content"}</a>
          </div>}
        </div>
      {!_.isEmpty(myAssetList) && myAssetList?.length > 0 ? <>
        {from === "explore"? <div className='row'>
          {myAssetList.map((course, i) => {
            console.log("COURSE334454", course);
            return (
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                  <ProductCardFinwell
                    {...course}
                    key={`course-${i + 1}`}
                  />
                </div>
            );
          })}
          
          </div>:<Slider {...settings1} className="slider-gap">
          {
            myAssetList.map((course, i) => {
              console.log("COURSE334454", course);
            return (
              
              <ProductCardFinwell
                {...course}
                key={`course-${i + 1}`}
              />
             
            );
          })
          }


        </Slider>}
      </>:<NotFoundMsg showMsg={true} msgLine={"Content and resources aligned with your interests and goals will appear here."} />}
      </section>
    </>
  );
};

export default ForYou;